import React from 'react';
import { FormGroup, Label, Input, Button, Row, Col, Form } from 'reactstrap';
import { connect } from 'react-redux';
import { UsersGroupsAction } from 'redux/actions';

const AssignGroup = (props) => {

    let [assignedGroups,setAssignedGroups] = React.useState([]);

    React.useEffect(()=>{
        setAssignedGroups(props.assignedGroups)
    },[props.assignedGroups])

    const handleGroupChange = (event) =>{
        let assigned= [...assignedGroups];
        if(!event.target.checked){
            const index = assigned.indexOf(parseInt(event.target.value));
            (index > -1) && assigned.splice(index, 1);
        }else{
            assigned.push(parseInt(event.target.value));
        }
        setAssignedGroups(assigned)
    }

    const handleAssignRole = () => {
        props.assignGroups({group_ids:assignedGroups,user_id:props.userId})
    }

    return (
        <div>
            <Row>
                <Col lg={12} md={12} sm={6} xs={12}>
                    <Form>
                        {props.groups.map((item,index) => (
                            <FormGroup key={index} check inline style={{ padding: 10 }}>
                                <Label check>
                                    <Input value={item.id} onChange={handleGroupChange} checked={(assignedGroups.includes(item.id)) ? true : false} type="checkbox" /> {item.name}
                                </Label>
                            </FormGroup>
                        ))}
                        <FormGroup></FormGroup>
                        <Button color="primary" onClick={handleAssignRole} style={{ display: 'block', marginLeft: 'auto', marginBottom: '10px' }} size={'sm'} className="border-0">{'Save'}</Button>
                    </Form>
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = (state) =>({
});
const mapDispatchToProps = (dispatch) =>({
    assignGroups: (payload)=>dispatch(UsersGroupsAction.assignUserGroups(payload))
});
export default connect(mapStateToProps, mapDispatchToProps)(AssignGroup);
